import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { FONT_WEIGHT, FONT_SIZE, ALIGN } from '@latitude/core/utils/constants';
import { Outer, StyledText } from './FinePrint.styles';
const FinePrint = props => /*#__PURE__*/React.createElement(Outer, null, /*#__PURE__*/React.createElement(StyledText, {
  fontSize: FONT_SIZE.SMALL,
  fontWeight: FONT_WEIGHT.LIGHT,
  align: ALIGN.CENTER
}, ReactHtmlParser(props.data)));
export default FinePrint;